(function auditDefinition() {
    'use strict';
    angular.module('Entities')
        .service('auditService', [
            'restUrlBuilder', 'authExtend', function auditService(restUrlBuilder, auth) {

                var urlEDR = restUrlBuilder('edr');

                this.get = function get(desc) {
                    var params;

                    if (desc) {
                        params = {
                            OrganizationalUnitId: desc.organizationalUnitId,
                            UserId: desc.userId,
                            ActionType: undefined,
                            DateFrom: desc.dateFrom,
                            DateTo: desc.dateTo,
                            Page: desc.page,
                            ItemPerPage: desc.itemPerPage,
                            UserName: desc.nickName,
                            entityName: desc.entityName,
                            entityId: desc.entityId
                        };

                        if (desc.actionType) {
                            params.ActionType = desc.actionType.id;
                        }
                    }

                    return urlEDR.all('audit/GetAudits')
                        .get({ params: params });
                };

                this.getTypes = function getTypes() {
                    return urlEDR.all('Audit/GetActionTypes')
                        .get();
                };

                this.getById = function getById(id) {
                    return urlEDR.one('audit', id).get();
                };

                this.create = function (dto) {
                    if (dto == null)
                        throw "audit no puede ser null";

                    return urlEDR.all('audit')
                        .post(dto);
                };

                this.export = function (desc) {
                    var params;

                    if (desc) {
                        params = {
                            OrganizationalUnitId: desc.organizationalUnitId,
                            UserId: desc.userId,
                            ActionType: undefined,
                            DateFrom: desc.dateFrom,
                            DateTo: desc.dateTo,
                            Page: desc.page,
                            UserName: desc.nickName,
                            entityName: desc.entityName,
                            entityId: desc.entityId
                        };

                        if (desc.actionType) {
                            params.ActionType = desc.actionType.id;
                        }
                    }
                    return urlEDR.all('audit/Export').put(params);
                };

            }
        ]);
})();